import { FC, ReactNode, useEffect, useState } from "react";
import { StatusContainer } from "../styles";
import { Tooltip } from "shared/ui/tooltip";
import { DEPOSIT_STATUSES } from "shared/consts";

interface StatusProps {
  status: string;
  tooltipText?: string | null;
}

interface TooltipWrapProps {
  children: ReactNode
}

type StatusType = {
  name: string;
  text: string;
  icon: string;
  color: string;
  bg?: string;
}

export const Status: FC<StatusProps> = ({
  status,
  tooltipText
}) => {
  const [currentStatus, setCurrentStatus] = useState<StatusType | null>();

  useEffect(()=>{
    const finded = DEPOSIT_STATUSES.find(el=>el.name===status) || DEPOSIT_STATUSES.find(el=>el.name==='default');

    setCurrentStatus(finded);
  }, [status])

  const TooltipWrap: FC<TooltipWrapProps> = ({
    children
  }) => {
    if (tooltipText) {
      return <Tooltip label={tooltipText}>{children}</Tooltip>
    } else {
      return <>{children}</>
    }
  }

  // TODO tooltip payment_details
  if (currentStatus) {
    return (
        <TooltipWrap>
          <StatusContainer
            $color={currentStatus.color}
            $bg={currentStatus.bg}
          >
            <span>{currentStatus.text}</span>
            <i dangerouslySetInnerHTML={{__html:currentStatus.icon}}></i>
          </StatusContainer>
        </TooltipWrap>
    )
  } else {
    return <></>
  }
}